export default {
  en: {
    INSIGHT_DELETE_SUCCESS: 'Insight settings deleted successfully',
    INSIGHT_SAVE_SUCCESS: 'Insight settings saved successfully',
    INSIGHT_UPDATE_SUCCESS: 'Insight settings updated successfully',
    INSIGHT_DUPLICATE_SUCCESS: 'Insight settings duplicated successfully',
    INSIGHT_DELETE_FAILED: 'Unable to delete Insight settings',
    DEFAULT_INSIGHTS_TITLE: 'Insights'
  }
};
